module.exports = __webpack_public_path__ + "img/bg02.a50ffd8e.jpg";